import { Component } from '@angular/core';
import { LabelChipComponent } from "./label-chip.component";
import { ICellRendererAngularComp } from "ag-grid-angular";

@Component({
  selector: 'app-label-chip-renderer',
  standalone: true,
  imports: [LabelChipComponent],
  template: `<app-label-chip [status]="status"></app-label-chip>`
})
export class LabelChipRendererComponent implements ICellRendererAngularComp {
  status!: string;

  agInit(params: any): void {
    this.status = params.value;
  }

  refresh(): boolean {
    return false;
  }
}
